import React from 'react';
import MyLinks from './MyLinks';
import './LinksManager.css';

const LinksManager = () => {
  return (
    <div className="links-manager" data-testid="links-manager">
      <MyLinks />
    </div>
  );
};

export default LinksManager;
